/**
 * Data URL(Base64)을 File 객체로 변환합니다.
 * @param dataUrl Data URL (e.g. data:image/jpeg;base64,...)
 * @param fileName 파일 이름
 * @param mimeType MIME 타입 (선택 사항)
 */
export const dataUrlToFile = async (dataUrl: string, fileName: string, mimeType?: string): Promise<File> => {
  const arr = dataUrl.split(',');
  const header = arr[0];
  const b64 = arr[1] || '';
  const match = header.match(/data:(.*?);base64/);
  const mime = mimeType || (match ? match[1] : 'image/jpeg');
  
  const byteString = typeof window === 'undefined' ? Buffer.from(b64, 'base64').toString('binary') : atob(b64);
  const n = byteString.length;
  const u8arr = new Uint8Array(n);
  for (let i = 0; i < n; i++) {
    u8arr[i] = byteString.charCodeAt(i);
  }
  
  const ext = (mime.split('/')[1] || 'jpeg').toLowerCase();
  const name = fileName.includes('.') ? fileName : `${fileName}.${ext}`;

  return new File([u8arr as unknown as BlobPart], name, { type: mime });
};
